import { useEffect, useState } from "react";
import emitter from "../../utils/emitter";

export default function useController(
  eventTypeModal,
  onPayload,
  onClose,
  preventClose
) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = (event) => {
    event.currentTarget && setIsModalOpen(false);
    onClose && onClose();
    document.querySelector("body").classList.remove("open-modal");
  };
  const modalHandler = (data) => {
    onPayload && onPayload(data.payload);
    if (data.isOpen) {
      document.querySelector("body").classList.add("open-modal");
    }
    if (!data.isOpen) {
      document.querySelector("body").classList.remove("open-modal");
    }
    "isOpen" in data && setIsModalOpen(data.isOpen);
  };
  useEffect(() => {
    emitter.on(eventTypeModal, modalHandler);
    return () => {
      emitter.off(eventTypeModal, modalHandler);
      document.querySelector("body").classList.remove("open-modal");
    };
  }, []);
  useEffect(() => {
    return () => {
      setIsModalOpen(null);
    };
  }, []);
  return {
    isModalOpen,
    closeModal,
  };
}
